import React from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog';
import { SUPER_SPEED_ERROR_TITLE } from '../show-error-popup/constants';
const MSG = 'The Super Speed option is no longer available on our site. We can easily change production time to standard for all super speed items inside your cart.';
export const ConfirmTransformSuperSpeedItemsPopupComponent = ({
  open,
  onClose,
  onConfirm
}) => /*#__PURE__*/React.createElement(ConfirmDialog, {
  open: open,
  title: SUPER_SPEED_ERROR_TITLE,
  onCancel: onClose,
  onConfirm: onConfirm,
  msg: MSG,
  confirmText: "Confirm change"
});